export enum SectionHeroContentWidth {
  SMALL = 6,
  MEDIUM = 8,
  LARGE = 10,
  MAX = 12,
}

export enum SectionHeroHeight {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  RESPONSIVE = 'responsive',
}

export enum SectionHeroAlignment {
  LEFT = 'left',
  CENTER = 'center',
  CENTER_TOP = 'center-top',
}

export enum SectionHeroBackgroundColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum SectionHeroContentPosition {
  TOP = 'top',
  CENTER = 'center',
}
